import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@realtorSitesClient/components/ui/tabs";
import LoginTab from "./LoginTab";
import RegisterTab from "./RegisterTab";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,

      loginWith: {
        email: true,
      },

      userAttributes: {
        given_name: { required: true },
        family_name: { required: true },
        phone_number: { required: false },
      },

      signUpVerificationMethod: "code",

      passwordFormat: {
        minLength: 8,
        requireUppercase: true,
        requireLowercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    secure: import.meta.env.MODE.includes("local") ? false : true,
    sameSite: "strict",
  }),
);

export const Authenticator = ({
  defaultTab = "login",
  defaultUsername,
  defaultPassword,
}: {
  defaultTab?: "login" | "register";
  defaultUsername?: string;
  defaultPassword?: string;
}) => {
  return (
    <Tabs defaultValue={defaultTab}>
      <TabsList className="grid grid-cols-2 w-full">
        <TabsTrigger value="login">Login</TabsTrigger>
        <TabsTrigger value="register">Register</TabsTrigger>
      </TabsList>
      <TabsContent value="login">
        <LoginTab
          defaultUsername={defaultUsername}
          defaultPassword={defaultPassword}
        />
      </TabsContent>
      <TabsContent value="register">
        <RegisterTab />
      </TabsContent>
    </Tabs>
  );
};
